<h2 mat-dialog-title class="dialog-header">
  <div class="dialog-title-block">
    <div class="dialog-title-row">
      <div>
        <div class="dialog-title">{{uuid}}</div>
      </div>
      <button mat-stroked-button class="refresh-button" (click)="refresh()">
        <mat-icon>refresh</mat-icon>
        Actualizar
      </button>
    </div>
  </div>

  <button mat-icon-button class="close-btn" (click)="close()">
    <mat-icon>close</mat-icon>
  </button>
</h2>

<ng-container *ngIf="reservation; else cargando">
  <mat-dialog-content class="dialog-content">
    <section class="hero-summary">
      <div class="summary-chip">
        <span class="summary-label">{{'status'|traduccion}}</span>
        <span class="badge-state" [ngClass]="reservation.status.toLowerCase()">{{ reservation.status|traduccion }}</span>
      </div>
      <div class="summary-chip">
        <span class="summary-label">{{'type'|traduccion}}</span>
        <span class="type-pill" [ngClass]="reservation.type?.toLowerCase()">{{ reservation.type|traduccion }}</span>
      </div>
      <div class="summary-chip" *ngIf="reservation.reason">
        <span class="summary-label">Motivo</span>
        <strong>{{ reservation.reason|traduccion }}</strong>
      </div>
    </section>

    <div class="info-grid" appGridColumns [colsLg]="3" [colsMd]="2" [colsSm]="1" [colWidths]="[40, 30, 30]">
      <mat-card class="detail-card">
        <div class="card-heading">
          <h3>{{'reserve'|traduccion}}</h3>
          <mat-icon>event_note</mat-icon>
        </div>

        <div class="detail-list">
          <div class="detail-item" *ngIf="reservation?.userId">
            <span class="detail-label">{{'reserve.details.user'|traduccion}}</span>
            <strong>{{ reservation?.userId }}</strong>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{'startTime'|traduccion}}</span>
            <strong>{{ reservation.startTime | date: appService.FORMAT_DATETIME }}</strong>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{'endTime'|traduccion}}</span>
            <strong>{{ reservation.endTime | date: appService.FORMAT_DATETIME }}</strong>
          </div>
          <div class="detail-item editable-item">
            <span class="detail-label">{{'reserve.details.email'|traduccion}}</span>
            <input-editable [value]="reservation.email" (inputUpdated)="changeEmailReservation($event)"></input-editable>
          </div>
          <div class="detail-item editable-item">
            <span class="detail-label">{{'reserve.details.phone'|traduccion}}</span>
            <input-editable [value]="reservation.phone" (inputUpdated)="changePhoneReservation($event)"></input-editable>
          </div>
          <div *ngIf="reservation.lockerPassword.provisionalPassword" class="detail-item editable-item">
            <span class="detail-label">{{'provisionalPassword'|traduccion}}</span>
            <input-editable
              [value]="reservation.lockerPassword.provisionalPassword"
              (inputUpdated)="provisionalPasswordUpdated($event)">
            </input-editable>
          </div>
          <div *ngIf="reservation.lockerPassword.checkoutPassword" class="detail-item editable-item">
            <span *ngIf="!reservation.lockerPassword.provisionalPassword" class="detail-label">{{'checkoutPassword'|traduccion}}</span>
            <span *ngIf="reservation.lockerPassword.provisionalPassword" class="detail-label">{{'checkoutPasswordPickup'|traduccion}}</span>
            <input-editable
              [value]="reservation.lockerPassword.checkoutPassword"
              (inputUpdated)="checkoutPasswordUpdated($event)">
            </input-editable>
          </div>
          <div class="detail-item editable-item">
            <span class="detail-label">{{'typePassword'|traduccion}}</span>
            <input-editable
              [value]="reservation.lockerPassword.typePassword"
              [options]="typePasswordOptions"
              type="select"
              (inputUpdated)="typePasswordUpdated($event)">
            </input-editable>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{'createdAt'|traduccion}}</span>
            <strong>{{ reservation.createdAt | date: appService.FORMAT_DATETIME }}</strong>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{'updatedAt'|traduccion}}</span>
            <strong>{{ reservation.updatedAt | date: appService.FORMAT_DATETIME }}</strong>
          </div>
        </div>
      </mat-card>

      <mat-card class="detail-card">
        <div class="card-heading">
          <h3>{{'locker'|traduccion}}</h3>
          <mat-icon>inventory_2</mat-icon>
        </div>

        <div class="detail-list">
          <div class="detail-item editable-item">
            <span class="detail-label">{{'lockerId'|traduccion}}</span>
            <input-editable [value]="boxId" (inputUpdated)="lockerNumberUpdated($event)"></input-editable>
          </div>
          <div class="detail-item">
            <span class="detail-label">{{'category'|traduccion}}</span>
            <strong>{{ reservation.categoryCode }}</strong>
          </div>
          <div class="locker-action-row" *ngIf="boxId">
            <button mat-flat-button color="primary" type="button" (click)="openLocker()">
              <mat-icon>lock_open</mat-icon>
              {{'reserve.action.openLocker'|traduccion}}
            </button>
          </div>
        </div>
      </mat-card>

      <mat-card class="detail-card accent-card">
        <div class="card-heading">
          <h3>{{'payments'|traduccion}}</h3>
          <mat-icon>payments</mat-icon>
        </div>

        <div class="metric-stack">
          <div class="metric-item">
            <span class="metric-label">{{'totalPaid'|traduccion}}</span>
            <strong>{{ periods.totalPaid|currency }}</strong>
          </div>
          <div class="metric-item">
            <span class="metric-label">{{'periodToPay'|traduccion}}</span>
            <strong>{{ periods.periodToPay }} {{ periods.unitToPay|traduccion }}</strong>
          </div>
          <div class="metric-item">
            <span class="metric-label">{{'totalToPay'|traduccion}}</span>
            <strong>{{ periods.totalToPay|currency }}</strong>
          </div>
        </div>
      </mat-card>
    </div>

    <mat-card class="tracks-card">
      <div class="card-heading">
        <div>
          <h3>Movimientos de reserva</h3>
          <p>Consulta cada petición, pago o reembolso y abre su detalle.</p>
        </div>

        <button *ngIf="!isNew" mat-flat-button color="primary" class="extend-reservation-button" (click)="openManualReserve()">
          <mat-icon>more_time</mat-icon>
          Ampliar reserva
        </button>
      </div>

      <app-data-table
        class="tracks-desktop-view"
        tableClass="tracks-table"
        [dataSource]="reservationLinesDataSource"
        [displayedColumns]="displayedColumns"
        [emptyMessage]="'Sin movimientos asociados.'"
        [showPaginator]="true"
        [clientPagination]="true"
        [length]="reservationLines.length"
        [pageSize]="tracksPageSize"
        [pageIndex]="tracksPageIndex"
        [pageSizeOptions]="[3, 5, 10]"
        [rowClickable]="true"
        [rowClass]="'track-row'"
        (rowClick)="openDataPayment($event.row.line, $event.row.originalIndex)"
        (page)="onTracksPageChange($event)">
        <ng-container matColumnDef="startTime">
          <th mat-header-cell *matHeaderCellDef>{{'startTime'|traduccion}}</th>
          <td mat-cell *matCellDef="let element">{{element.line.startTime | date: appService.FORMAT_DATETIME }}</td>
        </ng-container>

        <ng-container matColumnDef="endTime">
          <th mat-header-cell *matHeaderCellDef>{{'endTime'|traduccion}}</th>
          <td mat-cell *matCellDef="let element">{{element.line.endTime | date: appService.FORMAT_DATETIME}}</td>
        </ng-container>

        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>{{'status'|traduccion}}</th>
          <td mat-cell *matCellDef="let element">
            <div *ngIf="!element.line.payment?.refund">
              <span class="mini-badge">{{ element.line.status|traduccion }}</span>
            </div>
            <div *ngIf="element.line.payment?.refund">
              <button mat-button color="primary" (click)="openDataRefund(element.line.payment?.refund, element.originalIndex);$event.stopPropagation();">
                {{ element.line.status|traduccion }}
              </button>
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="amountPeriod">
          <th mat-header-cell *matHeaderCellDef>{{'amountPeriod'|traduccion}}</th>
          <td mat-cell *matCellDef="let element">{{element.line.amountPeriod*element.line.period}} {{element.line.unit|traduccion}}</td>
        </ng-container>

        <ng-container matColumnDef="subtotal">
          <th mat-header-cell *matHeaderCellDef>{{'subtotal'|traduccion}}</th>
          <td mat-cell *matCellDef="let element"><strong>{{element.line.subtotal|currency}}</strong></td>
        </ng-container>
      </app-data-table>

      <div class="tracks-mobile-view" *ngIf="reservation.lines?.length; else noTracksMobile">
        <article
          class="track-mobile-card"
          *ngFor="let element of pagedReservationLines"
          (click)="openDataPayment(element.line, element.originalIndex)">
          <div class="track-mobile-top">
            <div>
              <span class="track-mobile-label">Movimiento</span>
              <strong class="track-mobile-title">Peticion {{ element.displayOrder }}</strong>
            </div>

            <ng-container *ngIf="!element.line.payment?.refund; else refundStatus">
              <span class="mini-badge">{{ element.line.status|traduccion }}</span>
            </ng-container>

            <ng-template #refundStatus>
              <button mat-stroked-button color="primary" class="refund-button" (click)="openDataRefund(element.line.payment?.refund, element.originalIndex); $event.stopPropagation();">
                {{ element.line.status|traduccion }}
              </button>
            </ng-template>
          </div>

          <div class="track-mobile-grid">
            <div class="track-mobile-item">
              <span class="track-mobile-label">{{'startTime'|traduccion}}</span>
              <strong>{{element.line.startTime | date: appService.FORMAT_DATETIME }}</strong>
            </div>
            <div class="track-mobile-item">
              <span class="track-mobile-label">{{'endTime'|traduccion}}</span>
              <strong>{{element.line.endTime | date: appService.FORMAT_DATETIME}}</strong>
            </div>
            <div class="track-mobile-item">
              <span class="track-mobile-label">Periodo</span>
              <strong>{{element.line.amountPeriod*element.line.period}} {{element.line.unit|traduccion}}</strong>
            </div>
            <div class="track-mobile-item">
              <span class="track-mobile-label">{{'subtotal'|traduccion}}</span>
              <strong>{{element.line.subtotal|currency}}</strong>
            </div>
          </div>
        </article>

        <mat-paginator
          class="tracks-mobile-paginator"
          [length]="reservationLines.length"
          [pageSize]="tracksPageSize"
          [pageIndex]="tracksPageIndex"
          [pageSizeOptions]="[3, 5, 10]"
          [showFirstLastButtons]="true"
          (page)="onTracksPageChange($event)">
        </mat-paginator>
      </div>

      <ng-template #noTracksMobile>
        <div class="tracks-mobile-empty">
          Sin movimientos asociados.
        </div>
      </ng-template>
    </mat-card>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-footer">
    <ng-container *ngIf="!isNew">
      <button mat-stroked-button color="warn" (click)="closeReservation()">
        <mat-icon>close</mat-icon>
        {{'reserve.action.close'|traduccion}}
      </button>
      <button *ngIf="reservation.status=='CLOSED'" mat-stroked-button (click)="reopenReserve()">
        <mat-icon>reopen_window</mat-icon>
        {{'reserve.action.reopen'|traduccion}}
      </button>
      <button *appShowForRoles="['ROLE_ADMIN']" mat-stroked-button (click)="syncReservation()">
        <mat-icon>sync</mat-icon>
        {{'reserve.action.sync'|traduccion}}
      </button>
      <button *appShowForRoles="['ROLE_ADMIN']" mat-stroked-button (click)="snapshotReservation()">
        <mat-icon>cloud_download</mat-icon>
        {{'reserve.action.snapshot'|traduccion}}
      </button>
      <button mat-flat-button color="primary" (click)="openDataHistorical(reservation.uuid)">
        <mat-icon>history_edu</mat-icon>
        {{'reserve.action.history'|traduccion}}
      </button>
    </ng-container>
  </mat-dialog-actions>
</ng-container>

<ng-template #cargando>
  <div class="loading-state">
    <mat-progress-spinner mode="indeterminate" diameter="32"></mat-progress-spinner>
    <p>Cargando datos...</p>
  </div>
</ng-template>
